import CommonStyleEditor from "./CommonStyleEditor";
import HtmlPicker from "../picker/HtmlPicker";
import AIPicker from "../picker/AIPicker";

export default function HtmlCellProperties({ cell, onChange }) {
    return (
        <div className="property-section">
            <div className="property-section-title">Html</div>
            <div className="property-row">
                <HtmlPicker 
                    value={cell.html} 
                    onChange={(html) => onChange(cell.cell_id, { html, type: cell.type })}
                />
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
            <AIPicker type="component" onResult={(result) => { onChange(cell.cell_id, { html: result.data, type: cell.type })}}/>
        </div>
    )
}
